import { List, Map } from "immutable";
import { FILTER_KEY, SMU_FILTER } from "constants/product-collection";
import { amphibiousGetIn } from "helpers/objUtils";

export const filterItems = (
    items: List<any>,
    searchableFields: string[][],
    filters?: Map<string, string>,
    searchTerm?: string,
) => {
    if (!searchTerm && !filters) {
        return items;
    }

    const searchTokens = tokenizeSearchTerm(searchTerm);
    const filterTokens = (filters || Map()).map((filterTerm) => {
        return tokenizeSearchTerm(filterTerm);
    });

    if (!searchTokens.length && !filterTokens.size) {
        return items;
    }

    return items.filter((data) => {
        // Search Term
        if (searchTokens.length && filterTokens.size) {
            if (
                !isDataMatchingSearchTerm(data, searchTokens, searchableFields) ||
                !isDataMatchingFilters(data, filterTokens)
            ) {
                return false;
            }
        } else if (searchTokens.length) {
            if (!isDataMatchingSearchTerm(data, searchTokens, searchableFields)) {
                return false;
            }
        } else if (filterTokens.size) {
            if (!isDataMatchingFilters(data, filterTokens)) {
                return false;
            }
        }
        return true;
    }) as List<any>;
};

const isDataMatchingSearchTerm = (data, searchTokens, searchableFields) => {
    const nonMatches = searchTokens.slice();
    for (const field of searchableFields) {
        const value = (amphibiousGetIn(data, field) || "").toString().toUpperCase();
        for (let i = 0; i < nonMatches.length; i++) {
            if (value.toString().indexOf(nonMatches[i]) !== -1) {
                nonMatches.splice(i, 1);
                i--;
                if (nonMatches.length === 0) {
                    return true;
                }
            }
        }
    }
    return false;
};

const isDataMatchingFilters = (data, filterTokens) => {
    const matches = filterTokens.filter((value, key) => {
        switch (key) {
            case FILTER_KEY.ProductID:
                // Note: Value is an array (for now?)
                if (value[0] === SMU_FILTER.ExcludeSMU.toUpperCase()) {
                    return !!amphibiousGetIn(data, ["fields", key, "string_value"]);
                } else {
                    return !amphibiousGetIn(data, ["fields", key, "string_value"]);
                }
            default:
                return isDataMatchingSearchTerm(data, value, [["fields", key, "string_value"]]);
        }
    });
    return matches.size === filterTokens.size;
};

const tokenizeSearchTerm = (searchTerm) => {
    if (!searchTerm) {
        return [];
    }
    return searchTerm.toUpperCase().split(" ");
};
